<template>
  <v-dialog v-model="dialog" width="600" class="semi-rounded">
    <v-card color="white" class="px-8 py-12 semi-rounded">
        <v-layout
        style="color: var(--primary-color-blue);"
        class="flex-column justify-center align-center title text-center"
        >
        <v-img
            max-width="100"
            max-height="100"
            :src="qrCheck"
        ></v-img>
        <span class="py-6">{{
            $t('redeem_tag_dialog.text')
        }}</span>
        <v-btn
            style="background: var(--primary-color-blue); color: white; border-radius: 16px !important;"
            class="py-8 px-10 mt-6 w-100"
            x-large
            @click="dialog = false"
        >
            {{ $t("actions.ok") }}
        </v-btn>
        </v-layout>
    </v-card>
    </v-dialog>
</template>
<script>
export default {
  props: ["dialogData", "hideIcon"],
  data() {
    return {
      dialog: false,
      qrCheck: require('@/assets/images/qr_check.png')
    };
  },
};
</script>
